import { useContext, useEffect } from 'react';
import FormContext from '../contexts/form/formContext';
import { useParams, Link } from 'react-router-dom';
import NumberFormat from 'react-number-format';
import { FlwBtnComp, FlwTxtComp } from './payment/FlwBtn';

const SuccessComp = () => {
  const { code } = useParams();
  const { payObj, getPayDetails } = useContext(FormContext);

  useEffect(() => {
    getPayDetails(code);
    //eslint-disable-next-line
  }, []);

  return (
    <div className="py-10 text-lg text-left">
      {payObj.msg !== 'not found' ? (
        <section className="px-1">
          <div className="bg-white rounded-md mb-2 p-3 drop-shadow-md">
            <h2 className="text-xl">
              Thank you for registering {payObj.schoolName} for the{' '}
              <span className="font-medium">
                {' '}
                NATIONAL DIGITAL LITERACY COMPETITION 2022
              </span>
              .
            </h2>
            <br />
            <p>
              We sent an email to:{' '}
              <span className="font-bold">{payObj.email}</span> containing your
              registration information. You are required to make payment of{' '}
              {payObj.participants ? (
                <>
                  <NumberFormat
                    value={payObj.participants * 1000}
                    thousandSeparator={true}
                    displayType="text"
                    prefix="₦"
                    className="font-bold"
                  />{' '}
                  for the {payObj.participants} student(s){' '}
                </>
              ) : (
                <>
                  <NumberFormat
                    value={payObj.participants * 1000}
                    thousandSeparator={true}
                    displayType="text"
                    prefix="₦"
                    className="font-bold"
                  />{' '}
                  for the student{' '}
                </>
              )}
              you registered for the competition to complete your registration.
            </p>
            <br />
            <p>
              <span>NB: N1,000 Registration Fee per contestants.</span>
              <br />
              <br />
              Click <FlwTxtComp code={code} /> to make payment with your
              credit/debit card Or Pay using bank transfer: (Bank informations
              will be supplied)
            </p>
          </div>
          <br />
          <div className="p-3 bg-white rounded-md drop-shadow-md">
            <p>
              <span className="font-medium">Account Name</span>: Meghee
            </p>
            <p>
              <span className="font-medium">Account Number</span>: 2035385189
            </p>
            <p>
              <span className="font-medium">Bank Name</span>: First Bank
            </p>
            <br />
            <p>
              Kindly send your receipt of Bank transfer to 07032460187 on{' '}
              <a
                href="https://wa.me/2347032460187"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-500 font-md text-xl"
              >
                Whatsapp
              </a>{' '}
              or Call 07032460187, 08068202793 to confirm your payment.
            </p>
            <br />
            <p>
              For feedback and support, please reach out to our team with the
              contact details below:
              <br />
              <br />
              <span>07032460187, 08068202793</span>
            </p>
          </div>
          <FlwBtnComp code={code} />
          <div className="my-4">
            <p>
              Learn more about the competition &amp; Prizes{' '}
              <a
                href="http://www.ndl.cloudnotte.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-cyan-400 font-medium text-xl"
              >
                here
              </a>{' '}
              - Join our Whatsapp Group{' '}
              <a
                href="https://chat.whatsapp.com/CLIdEHNXVJh7Ro2kcsTu45"
                target="_blank"
                rel="noopener noreferrer"
                className="text-green-400 font-medium text-xl"
              >
                here
              </a>
            </p>
          </div>
        </section>
      ) : (
        <>
          <div className="text-2xl flex h-screen text-center">
            <div className="m-auto">
              <p className="mb-16">
                Please check your mail and click the payment button
              </p>
              <Link to="/" className="px-3 py-1 bg-amber-400 rounded-md">
                Go Back
              </Link>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default SuccessComp;
